import { Fragment, useEffect } from 'react'

import useSubscriptionWallForFamily from '~/subscription/hooks/useSubscriptionWallForFamily'

export default function GameWrapper({ children }: { children: React.ReactElement }): React.ReactElement {
  const subscriptionIsRequired = useSubscriptionWallForFamily()

  useEffect(() => {
    const isRequired = subscriptionIsRequired()
    if (isRequired) {
      document.getElementsByTagName('iframe')?.item(0)?.classList?.add('pointer-events-none')
    } else {
      document.getElementsByTagName('iframe')?.item(0)?.classList?.remove('pointer-events-none')
    }
  }, [subscriptionIsRequired])

  return <Fragment>{children}</Fragment>
}
